module.exports = __webpack_public_path__ + "img/in-depth.422c7f77.svg";